import { ChartLineIcon } from './ChartLineIcon';

/**
 * author: Austin Andrews
 * id D996574D-5B42-47C5-91D6-F86555C2FBC5
 * name chart-line
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-line.svg
 * tags
 * - Math 
 */
export const ReportLineIcon = ChartLineIcon;
export default ReportLineIcon